// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CompleteIntegrationCallRequestModel from '../../model/complete-integration-call-request-model';
import CompleteIntegrationCallRequestDTO from '../dto/complete-integration-call-request-dto';
import dtoSchema from '../schemas/complete-integration-call-request-schema';

export default abstract class CompleteIntegrationCallRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CompleteIntegrationCallRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
      this.comment = data.comment;
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @minimum 1
  */
  comment?: string;
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<CompleteIntegrationCallRequestDTO>): CompleteIntegrationCallRequestModel;
  static toModel(dto: DeepPartial<CompleteIntegrationCallRequestDTO> | undefined | null): CompleteIntegrationCallRequestModel | undefined;
  static toModel(dto: DeepPartial<CompleteIntegrationCallRequestDTO> | undefined | null): CompleteIntegrationCallRequestModel | undefined {
    return dto ? new CompleteIntegrationCallRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CompleteIntegrationCallRequestModel> | CompleteIntegrationCallRequestModel): CompleteIntegrationCallRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
      comment: unwrapped.comment,
      id: unwrapped.id,
    } as CompleteIntegrationCallRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CompleteIntegrationCallRequestModel, can not map to CompleteIntegrationCallRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
